<template>
  <el-container direction='vertical'>
    <div class="nut-tab-title">
      <span @click="tabSwitch(1)" :class="current === 1 ? 'nut-tab-active' :''" class="nut-title-nav-list ">
        <a href="javascript:void(0)" class="nut-tab-link">消费</a></span>
      <span @click="tabSwitch(2)" :class="current === 2 ? 'nut-tab-active' :''" class="nut-title-nav-list ">
        <a href="javascript:void(0)" class="nut-tab-link">充值</a>
      </span>
    </div>
    <div v-if="current===1" class="v-list-container">
      <div class="v-list" v-for="(item,i) in spendListData" :key='i'>
        <div class="cell-left">
          <p class="cell-title">{{item.shop_name}}</p>
          <p class="cell-sub-title">{{item.createtime}}</p>
        </div>
        <div class="cell-right">
          <p class="cell-spend">-￥{{item.amount}}</p>
          <p class="cell-balance">余额 (￥{{item.balance}})</p>
        </div>
      </div>
      <div v-if="isHasMore" class="check-more" @click="getMoreData">
        <div class="icon"></div>
      </div>
      <div v-if="!isHasMore && isHasText " class="check-no-more">哎呀，这里是底部了啦</div>
      <p v-if="spendListData.length === 0" class="v-tip">暂无数据</p>
    </div>
    <div v-if="current===2" class="v-list-container">
      <div class="v-list" v-for="(item,i) in rechargeListData" :key='i'>
        <div class="cell-left">
          <p class="cell-title">{{item.shop_name}}</p>
          <p class="cell-sub-title">{{item.createtime}}</p>
        </div>
        <div class="cell-right">
          <p class="cell-spend">+￥{{item.amount}}</p>
          <p class="cell-balance">余额 (￥{{item.balance}})</p>
        </div>
      </div>
      <div v-if="isHasMoreRecharge" class="check-more" @click="getMoreData">
        <div class="icon"></div>
      </div>
      <div v-if="!isHasMoreRecharge && isHasTextRecharge " class="check-no-more">哎呀，这里是底部了啦</div>
      <p v-if="rechargeListData.length === 0" class="v-tip">暂无数据</p>
    </div>
  </el-container>
</template>
<script>
import { getSpendList, getRechargeList } from '@/views/mobile/BillList/apis'
export default {
  data () {
    return {
      current: 1,
      spendListData: [],
      page: 1,
      size: 20,
      isHasMore: false,
      isHasText: false,
      rechargeListData: [],
      pagesRecharge: 1,
      sizeRecharge: 20,
      isHasMoreRecharge: false,
      isHasTextRecharge: false
    }
  },
  methods: {
    tabSwitch (index) {
      if (this.current !== index) {
        this.initData()
        this.current = index
        if (index === 1) {
          this.requestSpendList()
        } else {
          this.requestRechargeList()
        }
      }
    },
    initData () {
      this.page = 1
      this.pagesRecharge = 1
      this.spendListData = []
      this.rechargeListData = []
      this.isHasMore = false
      this.isHasText = false
      this.isHasMoreRecharge = false
      this.isHasTextRecharge = false
    },
    getMoreData () {
      if (this.current === 1) {
        this.requestSpendList()
      } else {
        this.requestRechargeList()
      }
    },
    requestSpendList () {
      this.loading = this.$toast.loading()
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      data.append('page', this.page)
      data.append('size', this.size)
      getSpendList(data)
        .then(result => {
          this.loading.hide()
          if (result) {
            this.spendListData = this.spendListData.concat(result.data.list)
            let allPages = result.data.pager.pages
            let records = result.data.pager.records
            if (records >= 8) {
              this.isHasText = true
            }
            if (this.page < allPages) {
              this.page = this.page + 1
              this.isHasMore = true
            } else {
              this.isHasMore = false
            }
          }
        }).catch(error => {
          if (error) {
            this.loading.hide()
          }
        })
    },
    requestRechargeList () {
      this.loading = this.$toast.loading()
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      data.append('page', this.pagesRecharge)
      data.append('size', this.sizeRecharge)
      getRechargeList(data)
        .then(result => {
          this.loading.hide()
          if (result) {
            this.rechargeListData = this.rechargeListData.concat(result.data.list)
            let allPages = result.data.pager.pages
            let records = result.data.pager.records
            if (records >= 8) {
              this.isHasTextRecharge = true
            }
            if (this.pagesRecharge < allPages) {
              this.pagesRecharge = this.pagesRecharge + 1
              this.isHasMoreRecharge = true
            } else {
              this.isHasMoreRecharge = false
            }
          }
        }).catch(error => {
          if (error) {
            this.loading.hide()
          }
        })
    }
  },
  mounted () {
    this.requestSpendList()
  },
  created () {
    let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'))
    let shop = window.location.hostname.split('.')[0]
    if (shop === 'szty') {
      document.title = '陶源酒家'
    } else if (userInfo.ext.shopname !== '') {
      document.title = userInfo.ext.shopname
    } else {
      document.title = '香港富临皇宫'
    }
  }
}
</script>
<style lang="less">
.v-list-container {
  padding: 0px 16px;
  // margin-top: 0.5rem;
  margin-top: 50px;
  .v-tip {
    position: absolute;
    top: 36%;
    color: #848484;
    width: 100%;
    text-align: center;
    left: 0;
  }
}
.v-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ededed;
  padding: 8px 8px;
  p {
    margin: 0;
    padding: 0;
  }
  .cell-title {
    margin-bottom: 8px;
    font-size: 15px;
    color: #2d2d2d;
  }
  .cell-left {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    flex-direction: column;
  }
  .cell-sub-title {
    line-height: 1;
    font-size: 12px;
    color: #848484;
  }
  .cell-spend {
    color: rgb(255, 0, 0);
    font-size: 18px;
    text-align: right;
    margin-bottom: 4px;
  }
  .cell-balance {
    color: rgb(255, 170, 0);
    font-size: 12px;
    text-align: right;
  }
}
.check-more {
  font-size: 14px;
  text-align: center;
  color: #848484;
  cursor: pointer;
  height: 36px;
}
.check-more .icon {
  height: 24px;
  width: 24px;
  background-image: url(assets/images/more.png);
  background-size: 100%;
  display: inline-block;
  margin-top: 6px;
}
.check-no-more {
  font-size: 12px;
  text-align: center;
  color: #848484;
  font-size: 12px;
  line-height: 36px;
}
.wrapper-mobile {
  .nut-tab {
    padding: 0;
  }
  .nut-cell-box {
    // padding: 0.12rem 0;
    padding: 12px 0;
  }
  .nut-tab-title {
    border: 0;
    position: fixed;
    margin: 0 auto;
    top: 0;
    left: 0;
    // height: 0.5rem;
    height: 50px;
    margin: 0 auto;
  }
  .nut-tab-item {
    height: auto;
    margin-top: 50px;
    // margin-top: 0.5rem;
  }
  .nut-title-nav-list {
    border-bottom: 1px solid #ededed;
  }
  .nut-tab-link {
    // font-size: 0.15rem;
    font-size: 16px;
  }
  .nut-tab-active {
    border-bottom: 1px solid red;
    .nut-tab-link {
      color: red;
      font-weight: 200;
      // font-size: 0.15rem;
      font-size: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/BillList/index.vue